import enMessages from '../locales/sv_SE.json';

const SvLang = {
  messages: {
    ...enMessages
  },
  locale: 'se',
};
export default SvLang;
